import React, { useEffect, useState,useMemo, useContext } from "react";
import { useDispatch } from "react-redux";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import Input from "components/input/input";
import Select from "components/select/select";
import _ from "lodash";
import LoadingIndicator from "assets/svg/loading-indicator";
import { gender, pronoun, sampleCategory } from "utils/constant";
import { generateNDigitID } from "utils/utils";
import toast from "react-hot-toast";
import { ADD_PROFILE } from "redux/modules/user/types";
// import { usePlacesWidget } from "react-google-autocomplete";
import CreatableSelect from "components/select/creatable";
import { useTranslation } from "react-i18next";
import Members from "components/settings/component/Members";
import update from "immutability-helper";
import DatePicker from "components/datepicker/datepicker";
import TextArea from "components/textarea/textarea";
import AutoCompleteAddress from "components/google-address/auto-complete";
import { SubscriptionContext } from "context/subscription";
import UpgradePremium from "components/subscription/upgrade-premium";
import PopInfo from "components/info-popup/pop-info";
import WYSIWYGEditor from "components/wysiwyg/wysiwyg";
import { useOccupations } from "redux/modules/occupation/hooks";
const existingUsernameCache = new Set();


const CREATEPROFILE = "CREATEPROFILE";
const PROFILETYPE = "PROFILETYPE";
export default function AddProfile({ hide, userData, ...props }) {
  
  const { http } = global.services;
  const {t} = useTranslation();
  const [steps, setSteps] = useState(CREATEPROFILE);
  const [members, setMembers] = useState([{ name: "", role: "", dateSE: "" }]);
  const { isSubscribed } = useContext(SubscriptionContext);
  // const { profiles } = useSelector((state) => state.user); 
  // const countCharacter = profiles.filter(item => item?.profile_type?.type === 'character').length ?? 0;
  const {
      addOccupation,
    } = useOccupations();
  const profileTypes = [
    { label: t("group"), value: "group" },
    { label: t("business"), value: "business" },
    { label: t("team"), value: "team" },
    // { label: countCharacter >= 1 ? t("character_more") : 'character', value: "character" },
    { label: t("character") , value: "character_more" },
  ];

  const gender = [
    { label: t("male"), value: "Male" }, 
    { label: t("female"), value: "Female" },
    { label: t("other"), value: "Other" }
  ];
  const [options, setOptions] = useState({
    occupations: [],
  });
  const [occupation, setOccupation] = useState([]);
  const [state, setState] = useState({
    profile_name: null,
    gender: null,
    validationErrors: null,
    loading: false,
    bio:'',
    birth_location:'',
    city: '',
    state: '',
    country: '',
    birthdate:null,
    profileTypes:null,
    username:null
  });

  // const { ref } = usePlacesWidget({
  //   apiKey:process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  //   onPlaceSelected: (place) => {
  //     setState((prev) => ({
  //       ...prev,
  //       address: place.formatted_address,
  //       validationErrors: { ...state.validationErrors, address: null },
  //     }));
  //   }
  // });

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
  };


  const handleAddressChange = (fieldName, addressValue) => {
    setState((prev) => ({
      ...prev,
      [fieldName]: addressValue,
      validationErrors: { ...prev.validationErrors, [fieldName]: null },
    }));
  };

  const handleSelectAddress = (parsed) => {
    setState((prev) => ({
      ...prev,
      city: parsed.city,
      state: parsed.state,
      country: parsed.country,
    }));
  };

  const handleDateChange = (e) =>{
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
  }

  const onChangeOccupation = (e) => {
    setOccupation(e);
  };

  const submit = async (e) => {
    // e.preventDefault();s
    setState((prev) => ({ ...prev, loading: true }));

    let payload = _.clone(state);
    payload.profileTypes = state.profileTypes === 'character_more' ? 'character' : state.profileTypes;

    if (occupation.length > 0) {
      let occupationValues = occupation.map((o) => o.label);
      payload.occupations = JSON.stringify(occupationValues);
    } else {
      payload.occupations = null;
    }

    payload.user_id = userData.user.id;
    payload.members = JSON.stringify(members);

    try {
      const { data } = await http.post("public/profiles/add-profile", payload);

      dispatch({
        type: ADD_PROFILE,
        payload: data.data,
      });

      hide({ success: true, id: data.data.id });
    } catch (error) {
      if(error.data?.errors?.username || error.data?.errors?.profile_name){
        setSteps(CREATEPROFILE);
      }
      if (error.status === 422)
        return setState((prev) => ({
          ...prev,
          validationErrors: error.data?.errors,
        }));

      toast.error(
        error.status === 401
          ? "Invalid Credentials"
          : error?.data?.message || "It appears that something went wrong"
      );
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

    const showMembers = useMemo(() => {
      let isGroup = state?.profileTypes === "group";
      let isTeam = state?.profileTypes === "team";
      let isBusiness = state?.profileTypes === "business";
      if (isGroup || isTeam || isBusiness) {
        return true;
      } else {
        return false;
      }
    }, [state.profileTypes]);

    const showGender = useMemo(() => {
        let hasGender = !gender.filter((g) => g.value === state.gender).length;
        if (state.gender) {
          if (state.gender === "Other" || hasGender) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }, [state.gender]);

    const onChangeMembers = (e, index) => {
        e.stopPropagation();
    
        let name = "";
        if (e.target.name === `name-${index}`) {
          name = e.target.value;
        } else {
          name = members[index].name;
        }
    
        let role = "";
        if (e.target.name === `role-${index}`) {
          role = e.target.value;
        } else {
          role = members[index].role;
        }
    
        let dateSE = "";
        if (e.target.name === `dateSE-${index}`) {
          dateSE = e.target.value;
        } else {
          dateSE = members[index].dateSE;
        }
    
        let payload = _.clone(members);
        let result = update(payload, {
          [index]: {
            name: { $set: name },
            role: { $set: role },
            dateSE: { $set: dateSE },
          },
        });
        setMembers(result);
      };

  const validationFirstStep = ()=>{
    const firstFields = ['profile_name', 'username', 'profileTypes'];
    let addValidation = {};
    let isValid = true;

    for (const key of firstFields) {
      if (_.isEmpty(state?.[key])) {
        isValid = false;
        let readableKey = key
        .split('_')
        .map(word => word)
        .join(' ');
        if(key === 'profileTypes'){
          readableKey = `The profile types is required`
        }
        addValidation[key] = `The ${readableKey} is required`; 
      }
    }

    if (isValid) {
      setSteps(PROFILETYPE);
    } else {
      setState((prev) => ({
        ...prev,
        validationErrors: {
          ...prev.validationErrors,
          ...addValidation,
        },
      }));
    }
  }

  const Footer = () => {
    return (
      <>
        <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2">
          <Button
            buttonName={`${steps === CREATEPROFILE ? t("cancel") : 'Back'}`}
            buttonClass="bg-thBg py-4 px-8"
            buttonTextClass="text-black text-sm font-semibold"
            onClick={() => {
              if (steps === PROFILETYPE) {
                setSteps(CREATEPROFILE);
              }else if(steps === CREATEPROFILE){
                hide()
              } else {
                setSteps(PROFILETYPE);
              }
            }}
          />
          <Button
            key="save-btn-category"
            buttonName={`${steps === CREATEPROFILE ? t("next") : t("Create Profile")}`}
            buttonClass="bg-primary py-4 px-8"
            buttonTextClass="text-white text-sm font-semibold flex items-center"
            onClick={() => {
              if (steps !== CREATEPROFILE) {
                submit();
              } else {
                validationFirstStep()
              }
            }}
            loadingIcon={
              state.loading ? (
                <LoadingIndicator className="text-white w-4 h-4 ml-2" />
              ) : null
            }
          />
        </div>
      </>
    );
  };

  const getOccupations = async () => {
    try {
      const { data } = await http.get("public/occupations", {
        user_profile_id: userData.profile.id,
      });
      const options = data.map((opt) => ({
        label: opt.name,
        value: opt.id,
        profile_type:opt.profile_type
      }));
      setOptions((prev) => ({ ...prev, occupations: options }));
    } catch (err) {
      console.log("getOccupations", err);
    }
  };

  const createOccupation = async (value) => {
    try { 
      let { data } = await http.post("public/occupations", {
        user_id: userData.user.id,
        user_profile_id: userData.profile.id,
        occupation: value,
        profile_type:state.profileTypes === 'character_more' ? 'personal' :  state.profileTypes
      });
      setOccupation([...occupation, { label: value, value: data.data.id, profile_type:state.profileTypes }]);
      let tempOccupation = [...options.occupations, { label: value, value: data.data.id, profile_type:state.profileTypes === 'character_more' ? 'personal' :  state.profileTypes}]
      setOptions((prev) => ({...prev, occupations:tempOccupation}));
      addOccupation({
        label: value,
        value: data.data.id,
        profile_type:state.profileTypes
      });
    } catch (err) {
      console.log(err);
    }
  };

  // const randomNumber = (min, max) => {
  //   return Math.random() * (max - min) + min;
  // }

  useEffect(() => {
    getOccupations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddMembers = () => {
    let payload = _.clone(members);
    payload.push({ name: "", role: "", dateSE: "" });
    setMembers(payload);
  };

  const onRemoveMembers = (index) => {
    let payload = _.clone(members);
    let result = update(payload, { $splice: [[index, 1]] }); //remove
    setMembers(result);
  };

    const checkExistingUsername = async (username) => {
    console.log(existingUsernameCache);
    const cacheExists = existingUsernameCache.has(username);

    if (cacheExists) {
      return true;
    }

    const response = await http.post("/verify-username", { username });

    const existsInServer = response.data.exists;

    if (existsInServer === true) {
      existingUsernameCache.add(username);
    }

    return response.data.exists;
  };

  const handleUsernameBlur = async (e) => {
    if (!e.target.value) return;

    const exists = await checkExistingUsername(e.target.value);

    if (exists) {
      setState((s) => ({
        ...s,
        validationErrors: {
          ...s.validationErrors,
          username: "Username already exists",
        },
      }));
    }
  };

  const handleNameBlur = async (e) => {
      const pName = state.profile_name;
      if (!!pName) {
        if (!!state.username) return;
        let username = `${pName}`.toLowerCase().trim().replace(/\s+/gi, "");
        setState((s) => ({ ...s, username }));
  
        const isExisting = await checkExistingUsername(username);
  
        if (isExisting) {
          existingUsernameCache.add(username);
          // if profileName name existing then append a random number
          username += `${generateNDigitID()}`;
          setState((s) => ({ ...s, username }));
        }
      }
    };

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-17/20 2md:w-16/20 3md:w-14/20 4md:w-12/20 1xl:w-9/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      {
        steps === CREATEPROFILE ? 
        <div className="w-full">
          {/* header */}
          <ModalHeader
            title="Add Profile"
            hide={hide}
            showPopInfo
            popInfoType="add_account"
          />
          {
            isSubscribed ? 
            <>
              {/* content */}
              <div className="px-8.5 py-6">
                {/* profile */} 
                <div className="w-full">
                  <Input
                    inputContainerClass="form-input-container"
                    value={state?.profile_name || ""}
                    name="profile_name"
                    outsideLabel="Profile Name"
                    placeholder="Dame Edna Everage"
                    outsideLabelClass="text-sm font-bold text-darkerGray marked"
                    noLabelPaddingY="1rem"
                    type="text"
                    onChange={handleInputChange}
                    errorMessage={state.validationErrors?.profile_name}
                    onBlur={handleNameBlur}
                  />
                </div>
                <div className="w-full">
                  {/* forms */}
                  <Input
                    inputContainerClass="form-input-container"
                    value={state?.username || ""}
                    name="username"
                    outsideLabel="Username"
                    placeholder="username"
                    outsideLabelClass="text-sm font-bold text-darkerGray marked"
                    noLabelPaddingY="1rem"
                    type="text"
                    onChange={handleInputChange}
                    errorMessage={state.validationErrors?.username}
                    onBlur={handleUsernameBlur}
                  /> 
                </div> 
                <div className="w-full mt-4">
                  <div className="w-full">
                    <Select
                      outsideLabelClass="text-sm font-bold text-darkerGray marked"
                      label={t("profileTypes")}
                      labelClass="text-sm font-bold text-darkerGray marked"
                      options={profileTypes}
                      placeholder={t('selectType')}
                      name="type"
                      value={
                        state.profileTypes &&
                        profileTypes.filter((pt) => pt.value === state.profileTypes)
                      }
                      onChange={(e) =>
                        handleInputChange({
                          target: { name: "profileTypes", value: e.value },
                        })
                      }
                      errorMessage={state.validationErrors?.profileTypes}
                    />
                  </div> 
                </div>
              </div>
            </>
            : <UpgradePremium customHeadline="Add and Manage Profiles - Upgrade to Unlock" customText="Upgrade so you can create up to four additional profiles (groups, teams, characters or businesses) and access advanced profile management"/>
          }
        </div>
        :
        <div className="w-full">
          <ModalHeader
            title={profileTypes.find(i => i.value === state?.profileTypes)?.label}
            hide={hide}
            showPopInfo
            popInfoType={`${profileTypes.find(i => i.value === state?.profileTypes)?.value.toLowerCase()}_information`}
          />
          <div className="px-8.5 py-6">
          {/* profile */}
          <div className="w-full">
            {/* forms */}
            <Input
              inputContainerClass="form-input-container"
              value={state?.other_name || ""}
              name="other_name"
              outsideLabel={t('otherNames')}
              optional={true}
              placeholder={`${state.profileTypes === 'personal' || state.profileTypes === 'character_more' ? 'e.g Dame Edna Everage' : 'eg. ABC Group'}`}
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={state.validationErrors?.other_name}
            />
          </div>
          <div className="input-wrapper mb-4">
            <CreatableSelect
              formContainer = "form-input-container mb-1"
              className="capitalize"
              label={`${state.profileTypes === 'personal' || state.profileTypes === 'character_more' ? `${t('occupationsSkills')} (eg. Actor, Director)` : `${t('categoryType')} ${sampleCategory?.[state.profileTypes] || ''}`}`}
              options={options.occupations.filter(item => item.profile_type === (state.profileTypes === 'character_more' ? 'personal' : state.profileTypes) )}
              placeholder={`${state.profileTypes === 'personal' || state.profileTypes === 'character_more' ? t('selectOccupations') : 'Add Category or Type'}`}
              name="occupations"
              isMulti
              value={occupation}
              onChange={(e) => onChangeOccupation(e)}
              onCreateOption={createOccupation}
              labelClass="text-sm font-bold text-darkerGray leading-4 marked"
            />
            {
              (state.validationErrors?.occupations && occupation.length < 1) && 
              <p className="input-error-message">* {state.validationErrors?.occupations[0]}</p>
            }
          </div>
          {showMembers ? (
            <div className="w-full mt-2 3md:flex">
              <div className="w-full">
              <div className="w-full">
            <label html="Bio" className="text-sm font-bold text-darkerGray marked">Bio</label>
              {/* <TextArea
                formContainer="mt-1"
                defaultValue={""}
                name="bio"
                inputClass="p-4.5 text-base leading-6 text-lightBlack"
                rows={3}
                type="text"
                onChange={handleInputChange}
                errorMessage={state.validationErrors?.bio}
              /> */}
              <WYSIWYGEditor
                optional={false}
                value={state.bio}
                limitChar={2000}
                onChange={(value) =>
                  handleInputChange({
                    target: { name: "bio", value },
                  })
                }
                preserveWhitespace={true}
                minimalToolBar={true}
              />
              {
                (state.validationErrors?.bio) && 
                <p className="input-error-message -mt-8">* {state.validationErrors?.bio[0]}</p>
              }
          </div>
          <div className="w-full grid 4sm:grid-cols-2 gap-x-4 gap-y-2 mb-2 mt-4">
            <div className="form-input-container">
              <label for="date" className="text-sm font-bold text-darkerGray leading-4 block mb-3 marked">Date of Formation or Launch</label>
              <Input
                formContainer="w-full"
                icon="noLabel"
                value={state.formation_date || ""}
                outsideLabelClass="text-sm font-bold text-darkerGray"
                noLabelPaddingY="1rem"
                type="text"
                onChange={handleInputChange}
                name="formation_date"
                placeholder="Date of Formation"
                errorMessage={state.validationErrors?.formation_date && 'The formation or launch date field is required'}
              />
            </div>
            <div className="form-input-container">
                <label for="address" className="text-sm font-bold text-darkerGray leading-4 block mb-3">Formation Location</label>
                <AutoCompleteAddress
                    name="birth_location"
                    value={state?.birth_location}
                    onChange={handleAddressChange}
                    onSelect={(parsed) => { handleSelectAddress(parsed);}}
                    placeholder={`${["business","team", "group"].includes(state?.profileTypes) ? "Enter your location" : "Enter your home address"}`}
                    errorMessage={state.validationErrors?.birth_location}
                  />
                  {/* <div className="input-wrapper">
                    <input ref={ref}  
                      name="birth_location"
                      className="input-class w-full" type="text"
                      placeholder="Melbourne VIC, Australia" 
                      value={state?.birth_location || ""}
                      onChange={handleInputChange}
                      style={{
                        padding:  "1rem",
                      }}
                      />
                      {
                        state.validationErrors?.birth_location && 
                        <p className="input-error-message">* {state.validationErrors?.birth_location}</p>
                      }
                    </div> */}
            </div>
          </div>
              <div className="w-full mt-2">
                <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
                  <div className="w-full flex flex-row gap-x-2 items-center">
                    <p className="text-lg text-lightBlack font-semibold flex gap-2 items-center">
                    {
                      `${state?.profileTypes === 'business' ? 
                        'Team Members' : t("members")
                      }`
                    }
                    <PopInfo containerClass="relative" type={`${['group'].includes(state?.profileTypes) ? 'members' : 'members_team'}`} />
                    </p>
                  </div>
                </div>
                <Members
                  items={members}
                  setItems={setMembers}
                  errors={state.validationErrors}
                  onAdd={onAddMembers}
                  onChange={(e, index) => onChangeMembers(e, index)}
                  onRemove={(index) => onRemoveMembers(index)}
                  customStyle={
                    { 
                      left: "auto !important",
                      top: "auto !important",
                    }
                  }
                />
                </div>
              </div>
            </div>
          ): 
          (
            <div className="w-full">
              <div className="w-full grid 4sm:grid-cols-2 gap-x-4 gap-y-2 mb-2">
                <Select
                  label="Gender"
                  options={gender}
                  placeholder="Select Gender"
                  name="gender"
                  height={58}
                  value={
                    state.gender && gender.filter((g) => g.value === state.gender)
                  }
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "gender", value: e.value },
                    })
                  }
                  errorMessage={state.validationErrors?.gender}
                  labelClass="text-sm font-bold text-darkerGray leading-4 marked"
                />
                <Input
                  outsideLabel="Pronouns"
                  placeholder="Select Pronouns"
                  name="pronoun"
                  // value={
                  //   state.pronoun &&
                  //   pronoun.filter((g) => g.value === state.pronoun)
                  // }
                  outsideLabelClass="text-sm font-bold text-darkerGray"
                  noLabelPaddingY="1rem"
                  type="text"
                  onChange={handleInputChange}
                  errorMessage={state.validationErrors?.pronoun}
                  onBlur={handleNameBlur}
                />
              </div> 
              <div className="form-input-container">
                <label for="address" className="text-sm font-bold text-darkerGray leading-4">Location (eg city, state, country)</label>
                <div className="input-wrapper">
                  {/* <input ref={ref}  
                    className="input-class w-full" type="text" name="address" placeholder="Melbourne VIC, Australia" 
                    value={state?.address || ""}
                    onChange={handleInputChange}
                    style={{
                      padding:  "1rem",
                    }}s
                    /> */}
                    <AutoCompleteAddress
                      name="address"
                      value={state?.address}
                      onChange={handleAddressChange}
                      onSelect={(parsed) => { handleSelectAddress(parsed);}}
                      placeholder="Melbourne VIC, Australia"
                  />
                    {
                      state.validationErrors?.address && 
                      <p className="input-error-message">* {state.validationErrors?.address}</p>
                    }
                  </div>
              </div>
          </div>
          )
          }  
          </div>
        </div>
      }
      
        {/* end content */} 
    </Modal>
  );
}
